import React from 'react';

import { Colors } from 'theme/colors';
import { NakedIcon } from 'theme/icons';
import { ClearText } from './styles';

/**
 * Renders the clearance caret button
 *
 * @param props - clearance caret props
 * @returns Clearance caret button
 */
export function ClearanceCaret(props: Props) {
  const { onPress, isClearable, size, color, isSecure } = props;

  if (!isClearable) {
    return null;
  }

  return (
    <ClearText onPress={onPress} clearable={isClearable} secureTextEntry={isSecure}>
      <NakedIcon
        name="close"
        size={size}
        color={color}
      />
    </ClearText>
  );
}
/** Type definitions */
interface Props {
  /** Caret icon size */
  size: number;
  /** Caret icon color */
  color: Colors;
  /** True, when the button is supposed to be visible */
  isClearable: boolean;
  /** True, is the input is a secure entry */
  isSecure: boolean;
  /** Emits an `onPress` event when the button is pressed */
  onPress(): void;
}
